const LABELS = { customers: "Customers", drivers: "Drivers", assets: "Assets", locations: "Locations", users: "Users & Mechanics", requesters: "Requesters" };
const METRICS = [["added", "Add"], ["updated", "Update"], ["unchanged", "Unchanged"], ["preserved", "Live-Only Kept"]];

export const CoreSyncSummary = ({ summary = {} }) => (
  <div className="space-y-3" data-testid="core-sync-summary">
    {Object.entries(LABELS).map(([collection, label]) => {
      const row = summary[collection];
      if (!row) return null;
      return <section key={collection} className="rounded-md border border-slate-700/50 p-3" data-testid={`core-sync-summary-${collection}`}>
        <h3 className="text-sm font-semibold text-slate-200" data-testid={`core-sync-label-${collection}`}>{label}</h3>
        <dl className="mt-2 grid grid-cols-2 sm:grid-cols-4 gap-x-3 gap-y-2">
          {METRICS.map(([key, name]) => <div key={key}>
            <dt className="text-[10px] uppercase tracking-wide text-slate-500">{name}</dt>
            <dd className="font-mono text-lg text-slate-100" data-testid={`core-sync-count-${collection}-${key}`}>{row[key] || 0}</dd>
          </div>)}
        </dl>
        {!!row.credentials_updated && <p className="mt-2 text-xs text-amber-400" data-testid={`core-sync-credentials-${collection}`}>{row.credentials_updated} existing accounts will need to sign in again</p>}
        {!!row.examples?.length && <p className="mt-2 text-xs text-slate-400 break-words" data-testid={`core-sync-examples-${collection}`}>Examples: {row.examples.map((item) => item.name).join(", ")}</p>}
      </section>;
    })}
  </div>
);
